export default "__VITE_ASSET__smFiVA30__"